import { SUPPLY_NODE } from '../enums/otc.enum';

const OTC_DEFAULT_VALUES = {
  amountNode: undefined,
  pricePerNode: undefined,
  supply: SUPPLY_NODE.CUT_FROM_HIGHEST_TIER,
  token: 'USDT',
  startedTime: undefined,
  startedDate: undefined,
  closingTime: undefined,
  closingDate: undefined,
  recipients: [],
};

const SUPPLY_NODE_DEFAULT = [
  { value: SUPPLY_NODE.CUT_FROM_HIGHEST_TIER, label: 'Deduct from the highest tier supply' },
  {
    value: SUPPLY_NODE.CUT_FROM_CURRENT_TIER,
    label: 'Reduce from the current tier supply',
  },
  {
    label: 'Increase total project supply',
    value: SUPPLY_NODE.ONLY_MINT,
  },
];

const OTC_STATUS: Record<string, string> = {
  PAID: 'success',
  UNPAID: 'normal',
  LIVE: 'success',
  ARCHIVED: 'normal',
};

export { OTC_DEFAULT_VALUES, SUPPLY_NODE_DEFAULT, OTC_STATUS };
